<template>
    <div v-show="isReady">
        <div>
            <div>
                <div class="flex-column flex-lg-row">
                    <div class="flex-lg-row-fluid mb-10 mb-lg-0">
                        <div class="card">
                            <div class="card-header flex-wrap border-0 pt-6 pb-0">
                                <div class="card-title">
              <router-link :to="{ name: 'store-details-entries', params: { id: $route.params.id } }" class="btn btn-sm btn-light me-4">
                <i class="bi bi-arrow-left me-1"></i>{{ $t('back') }}
              </router-link>
                                    <div class="d-flex align-items-center flex-equal fw-row me-4 order-2"
                                        data-bs-toggle="tooltip" data-bs-trigger="hover">
                                        <div class="fs-6 fw-bolder text-gray-700 text-nowrap">{{
                                            $t('store.output.create.date')
                                        }}</div>
                                        <div class="position-relative d-flex align-items-center w-250px">
                                            <input class="form-control form-control-transparent fw-bolder pe-5" id="kt_hbd"
                                                v-model="formContentOutput.date"
                                                :placeholder="$t('store.entrie.create.date_placeholder')"
                                                name="invoice_date" />
                                            <span class="svg-icon svg-icon-2 position-absolute ms-4 end-0">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                    viewBox="0 0 24 24" fill="none">
                                                    <path
                                                        d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                                                        fill="currentColor" />
                                                </svg>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-toolbar">
                                    <div class="text-nowrap order-1 order-xxl-2 me-4">
                                        <div class="d-flex flex-center flex-equal fw-row" data-bs-toggle="tooltip"
                                            data-bs-trigger="hover" title="Enter invoice number">
                                            <span class="fs-2 fw-bolder text-gray-800">{{
                                                $t('store.output.titre')
                                            }} : </span>
                                            <input readonly type="text"
                                                class="form-control form-control-flush fw-bolder text-muted fs-3 w-250px"
                                                v-model="formContentOutput.numero"
                                                :placeholder="$t('store.output.numero')" />
                                        </div>
                                        <button disabled class="btn btn-light-danger border"
                                            style="width:100%; text-align: center">
                                            {{ formContentOutput.status }}
                                        </button>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-end flex-equal order-3 fw-row"
                                        data-bs-toggle="tooltip" data-bs-trigger="hover" title="Specify invoice due date">
                                        <div class="fs-6 fw-bolder text-gray-700 text-nowrap">{{ $t('store.name') }}
                                            :</div>
                                        <div class="position-relative d-flex align-items-center w-150px">
                                            <input class="form-control form-control-transparent fw-bolder pe-5" readonly
                                                :value="store?.name" />

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="separator separator-dashed my-10"></div>
                            <div class="card-body p-12">
                                <div class="mb-0">
                                    <div class="card">
                                        <div class="card-body mt-4 rounded bg-light"
                                            v-for="(item, key) in formContentOutput.items" :key="key">
                                            <div class="form-group row">
                                                <div class="col-sm-3">
                                                    <span class="fs-2 text-gray-800">
                                                        {{ $t('store.output.model') }}
                                                    </span>
                                                </div>
                                                <div class="col-sm-8 col-form-label">
                                                    <div class="form-check form-check-custom form-check-inline mb-2">
                                                        <input :id="'shop'+id" class="form-check-input me-2 h-20px w-20px form-check-success" @click="checkType('shop')" v-model="item.type" value="shop" required type="radio" />
                                                        <label class="form-check-label me-5" :for="'shop'+id">
                                                            <div class="text-gray-800"> {{$t("store.output.shop")}}</div>
                                                        </label>
                                                        
                                                        <input :id="'store'+id" class="form-check-input  me-2 h-20px w-20px form-check-success" @click="checkType('store')" v-model="item.type" value="store" required type="radio" />
                                                        <label class="form-check-label" :for="'store'+id">
                                                            <div class="text-gray-800"> {{$t("store.output.store")}}</div>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-sm-10">
                                                    <select :data-key="key" class="form-select kt_select2 mb-2"
                                                        data-control="select2" v-model="item.entityToable_id" name="shop"
                                                        data-allow-clear="false">
                                                        <option></option>
                                                        <option v-for="entity in entities" :key="entity.id" :value="entity.id">{{
                                                            entity.name }}</option>
                                                    </select>
                                                </div>
                                                <div class="col-sm-2">
                                                    <button @click.prevent="dropShopLigne(key)" type="button"
                                                        class="btn btn-sm btn-light-danger"><span
                                                            class="svg-icon svg-icon-3">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                                viewBox="0 0 24 24" fill="none">
                                                                <path
                                                                    d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                                                                    fill="currentColor" />
                                                                <path opacity="0.5"
                                                                    d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                                                                    fill="currentColor" />
                                                                <path opacity="0.5"
                                                                    d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                                                                    fill="currentColor" />
                                                            </svg>
                                                        </span>
                                                        {{ $t('product.delete') }}
                                                    </button>
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="row" v-for="(products, id) in item.products" :key="id">
                                                <div class="col-sm-5">
                                                    <select :data-item-key="key" :data-product-key="id"
                                                        class="mb-6 form-select kt_select2" data-control="select2"
                                                        v-model="products.product_sale_element_id"
                                                        name="product_sale_element_output_content"
                                                        :data-placeholder="$t('store.product_placeholder')"
                                                        data-allow-clear="false">
                                                        <option></option>
                                                      <optgroup v-for="group in groupProducts(filterProductSaleElements(key, id))" :key="group.category_id" :label="group.category_name">
                                                        <option v-for="product in group.products" :key="product.id" :value="product.id">{{ product.name }}</option>
                                                      </optgroup>
                                                    </select>
                                                </div>
                                              <div class="col-sm-3">
                                                <select :data-item-key="key" :data-product-key="id"
                                                        class="mb-6 form-select kt_select2" data-control="select2"
                                                        v-model="products.product_lot_id"
                                                        name="lot"
                                                        :data-placeholder="$t('store.entrie.create.lot')"
                                                        data-allow-clear="false">
                                                  <option v-for="lot in filterProductSaleElementLots(key, id, products.product_sale_element_id)"  :key="lot.id" :value="lot.id">
                                                    {{ lot.lot.name }} ({{ lot.lot.item_number }})
                                                  </option>
                                                </select>
                                              </div>
                                              <div class="col-sm-3">
                                                    <input type="number" v-model="products.quantity" min="0" :max="products.maxAvailableQuantity"
                                                        class="mb-6 form-control" name="date"
                                                        :placeholder="$t('store.output.create.product_quantity')" />
                                                </div>
                                                <div class="col-sm-1">
                                                    <button @click.prevent="dropProductLigne(key, id)" type="button"
                                                        class="btn btn-sm btn-icon text-danger btn-active-color-danger"
                                                        data-kt-element="remove-item">
                                                        <span class="svg-icon svg-icon-3">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                                viewBox="0 0 24 24" fill="none">
                                                                <path
                                                                    d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                                                                    fill="currentColor" />
                                                                <path opacity="0.5"
                                                                    d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                                                                    fill="currentColor" />
                                                                <path opacity="0.5"
                                                                    d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                                                                    fill="currentColor" />
                                                            </svg>
                                                        </span>
                                                    </button>
                                                </div>
                                                <hr>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-8"></div>
                                                <div class="col-sm-4">
                                                    <button @click.prevent="addLigneProduct(key)" type="button"
                                                        class="btn btn-sm btn-light-primary">
                                                        <i class="fa fa-plus"></i>
                                                        {{ $t('product.add_product') }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="row pt-4">
                                            <div class="col-sm-4">
                                                <button @click.prevent="addLigne" type="button"
                                                    class="btn btn-sm btn-light-primary">
                                                    <span class="svg-icon svg-icon-2">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                            viewBox="0 0 24 24" fill="none">
                                                            <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1"
                                                                transform="rotate(-90 11 18)" fill="currentColor" />
                                                            <rect x="6" y="11" width="12" height="2" rx="1"
                                                                fill="currentColor" />
                                                        </svg>
                                                    </span>
                                                    {{ $t('store.output.create.shop_add') }}
                                                </button>
                                            </div>
                                        </div> -->
                                        <div class="mt-5 d-flex justify-content-end">
                                            <button @click="sendUpdateOutput" class="btn btn-sm btn-success" style="margin-right: 5px" id="kt_invoice_submit_button"
                                                    :disabled="isLoading">
                                                <span class="indicator-label" v-if="!isLoading">{{ $t('button.send') }}</span>
                                                <span class="" v-else>{{ $t('loading') }}
                                                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </span>
                                            </button>
                                            <button @click="updateOutput" class="btn btn-sm btn-primary" id="kt_invoice_submit_button"
                                                :disabled="isLoading">
                                                <span class="indicator-label" v-if="!isLoading">{{ $t('button.save') }}</span>
                                                <span class="" v-else>{{ $t('loading') }}
                                                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <!--end::Wrapper-->

                                <!--end::Form-->
                            </div>
                            <!--end::Card body-->
                        </div>
                        <!--end::Card-->
                    </div>
                </div>
                <!--end::Layout-->
            </div>
            <!--end::Container-->
        </div>
    </div>
    <div class="text-center py-10" v-show="!isReady">
        <Loader />
    </div>
</template>


<script>
import AppSubHeader from "@/views/Settings/Stores/partials/AppSubHeaderStoreOutputUpdate.vue";
import Loader from "@/components/Loader.vue";
import { mapActions, mapGetters } from 'vuex'
import { groupProductsByCategory } from '@/composables/productCategoryGroups'
export default {
    components: {
        AppSubHeader,
        Loader,
    },
    data() {
        return {
            isLoading: false,
            productSaleElement:[],
            supplier: {},
            store: {},
            entrieDetails: {},
            quantity: 0,
            title: i18n.global.t('store.transfer'),
            breadcrumbs: [
                {
                name: i18n.global.t('breadcrumbs.setting.setting'),
                path: '/admin/settings-index/items'
                },
                {
                name: i18n.global.t('breadcrumbs.store.path'),
                path: '/admin/stores'
                },
                {
                name: i18n.global.t('breadcrumbs.store.output.edit_transfer'),
                path: '/admin/settings-index/store/' + this.$route.params.id + '/' + this.$route.params.id_content + '/content/output'
                }
            ],
            formContentOutput: {
                id: this.$route.params.id_content,
                entityFromable_id: this.$route.params.id,
                numero: '',
                type: 'store',
                date: '',
                status: '',
                items: [
                {
                  entityToable_id: null,
                  type: 'shop',
                  products: [
                    {
                      product_sale_element_id: null,
                      quantity: null,
                      comments: '',
                      maxAvailableQuantity: 0,
                      product_lot_id: null,
                    }
                  ],
                }
              ]
            },
            entities: {},
            productLot: [],
            porductSaleElementLots: [],
            placeholder: '',
            isReady: false
        }
    },
    watch: {
        'formContentOutput.type': function (currentValue, oldValue) {
            this.$nextTick(() => {
                this.checkType(currentValue)
            })
        },
      formContentOutputItemsLength: function () {
        this.$nextTick(() => {
          this.initSelect2({
            dateFormat: "d/m/Y",
          })
        })
      },
    },
    async mounted() {
    this.$store.dispatch('categories/loadCategories')
        this.isReady = false

        this.loadStore({status: "all", search: null})
        await this.loadShops({ status: "active", search: "" })
        await this.loadOutputStore()
        await this.getProductSale()
      this.initProductSaleElementLots()
        $("#kt_hbd").flatpickr({
            dateFormat: "d/m/Y",
        });

        this.initSelect2()
        
        this.isReady = true
    },
    computed: {
        ...mapGetters('shop', ['getShops']),
    ...mapGetters('categories', ['getCategories']),
        ...mapGetters('store', ['getStores']),

        formContentOutputItemsLength() {
            return JSON.stringify(this.formContentOutput)
        }
    },
    methods: {
      ...mapActions('products', ['loadProductSaleStore','getProductSaleElementLot','listProductLots']),

    groupProducts(products) {
      return groupProductsByCategory(products, this.getCategories)
    },
      ...mapActions('store',
        [   'loadStore', 'removeProdOutputStore',
            'removeShopOutputStore', 'showStore', 'updateOutputStore',
            'getDetailsProd', 'showOutputStore', 'sendOutputStore'
        ]),
        ...mapActions('shop', ['loadShops']),


      async initProductSaleElementLots() {
        let response = await this.listProductLots()
        this.porductSaleElementLots = response.data
      },
      sortByKey(array, key) {
        return array.sort(function (a, b) {
          var x = a[key].toLowerCase();
          var y = b[key].toLowerCase();
          if (x < y) {
            return -1;
          }
          if (x > y) {
            return 1;
          }
          return 0;
        });
      },

      filterProductSaleElements(key, id) {
        let productBeforeKey = [];

        for (let i = 0; i < id; i++) {
          const productSale = this.formContentOutput.items[key].products[i];
          if (this.filterProductSaleElementLots(key, i, productSale.product_sale_element_id).length === 0) {
            productBeforeKey.push(productSale.product_sale_element_id);
          }
        }

        let product_lists = this.productSaleElement.filter(product => !productBeforeKey.includes(product.id));
        return this.sortByKey(product_lists, "name");
      },
      filterProductSaleElementLots(key, id, product_sale_element_id) {
        if (product_sale_element_id != null && product_sale_element_id != 'undefined') {
          let newProductLots = this.porductSaleElementLots.filter(lot => lot.product_sale_element_id === product_sale_element_id);
          let productBeforeKey = this.formContentOutput.items[key].products
              .filter((data, i) => i < id)
              .map(data => data.product_lot_id);

          return newProductLots.filter(lot => !productBeforeKey.includes(lot.id));
        }
        return this.porductSaleElementLots
      },


      async loadOutputStore() {
            let response = {}
            try {
                let response1 = await this.showStore(this.$route.params.id)
                this.store = response1.data.store
                response = await this.showOutputStore(this.$route.params.id_content)
                this.formContentOutput.status = response.data.output.status
                this.formContentOutput.numero = response.data.output.numero
                this.formContentOutput.date = response.data.output.date
                this.formContentOutput.items = response.data.output.items

                this.$nextTick(() => {
                  this.initSelect2()
                })

                this.formContentOutput.items.filter((item) => {
                    this.checkType(item.type)
                })

            } catch (err) {
                if (response && response.data) {
                    window.toastr['error'](err)
                }
            }
        },

        checkType(value){
            if(value == 'store'){
                this.entities = this.getStores.filter((store) => {
                    return (store.id !== this.$route.params.id && store.etat == 'active')
                })
                this.placeholder = i18n.global.t('store.store_placeholder')
            }

            if(value == 'shop'){
                this.entities = this.getShops.filter((shop) => {
                    let stores = shop.stores.filter((store) => {
                        return store.id === this.$route.params.id
                    })
                    return shop.archive == false && stores.length
                })
                this.placeholder = i18n.global.t('store.shop_placeholder')
            }
            this.formContentOutput.type = 'store'
        },

        checkStatus(data) {
            return data == "Draft" ? true : false
        },

         loadDetailsProd(data) {
          this.getDetailsProd(data).then((response) => {
            this.entrieDetails = response.data.details
          })
        },

        async getProductSale() {
            await this.loadProductSaleStore(this.$route.params.id).then((response) => {
                this.productSaleElement = response.data.product_sale_element
            }).catch((err) => {
                window.toastr['error'](err)
            });
        },

        getQuantityById(productId) {
          for (const product of this.productSaleElement) {
            if (product.id === productId) {
              return product.quantity;
            }
          }
          return 0;
        },

        getFilteredProducts(key, k) {
            let productBeforeKey = this.formContentOutput.items[key].products
                .filter((data, i) => i < k)
                .map(data => data.product_sale_element_id)

            return Object.values(this.productSaleElement).filter(product => !productBeforeKey.includes(product.id))
        },

        addLigne() {
            this.formContentOutput.items.push(
                {
                    entityToable_id: null,
                    products: [
                        {
                            product_sale_element_id: null,
                            quantity: null,
                            comments: '',
                            maxAvailableQuantity: 0,
                            product_lot_id: null
                        }
                    ],
                }
            )
            this.initSelect2()
        },

        addLigneProduct(key) {
            this.formContentOutput.items[key].products.push(
                {
                    status: "Pending",
                    product_sale_element_id: null,
                    quantity: null,
                    comments: '',
                    maxAvailableQuantity: 0,
                    product_lot_id: null
                }
            )
            this.initSelect2()
        },

        formatProduct(items) {
            return (items.attribut.length > 0) ? ' (' + items.attribut + ')' : '';
        },

        async sendUpdateOutput() {
            let response = {}
            this.isLoading = true
            this.formContentOutput.status = 'Send'
            try {
                this.isLoading = false
                await this.updateOutputStore(this.formContentOutput)
                window.toastr['success'](i18n.global.t('notification.store.output_create'))
                this.$router.push({ name: 'store-details-entries', params: { id: this.$route.params.id } })
            } catch (e) {
                this.isLoading = false
                if (response && response.data) {
                    window.toastr['error'](response.data.error)
                }
            }
        },

        async updateOutput() {
            let response = {}
            this.isLoading = true
            try {
                this.isLoading = false
                response = await this.updateOutputStore(this.formContentOutput)
                window.toastr['success'](i18n.global.t('notification.store.output_update'))
                this.$router.push({ name: 'store-details-entries', params: { id: this.$route.params.id } })
                console.log(response)
            } catch (e) {
                this.isLoading = false
                if (response && response.data) {
                    window.toastr['error'](response.data.error)
                }
            }
        },

        async dropShopLigne(key) {
            let id = 0;
            id = this.formContentOutput.items[key].entityToable_id
            if (id != 0 && id) {
                Swal.fire({
                    title: i18n.global.t('store.output.swalTitle'),
                    text: i18n.global.t('store.swal_text'),
                    icon: "error",
                    showCancelButton: true,
                    confirmButtonText: i18n.global.t('store.output.yes'),
                    cancelButtonText: i18n.global.t('store.output.no'),
                }).then(async (result) => {
                    if (result.value) {
                        // Retrait local : l'enregistrement du bon remplace tout son contenu
                        this.formContentOutput.items.splice(key, 1)
                        window.toastr['success'](i18n.global.t('store.output.notification.line_delete'))
                    }
                });
            } else {
                this.formContentOutput.items.splice(key, 1)
            }
        },

        dropProductLigne(key, id) {
            let id_shop = 0;
            id_shop = this.formContentOutput.items[key].products[id].output_content_id
            Swal.fire({
                title: i18n.global.t('store.output.swalTitleDeleteProduct'),
                text: i18n.global.t('store.swal_text'),
                icon: "error",
                showCancelButton: true,
                confirmButtonText: i18n.global.t('store.output.yes'),
                cancelButtonText: i18n.global.t('store.output.no'),
            }).then(async (result) => {
                let response = {};
                if (result.isConfirmed) {
                    if (id_shop != 0 && id_shop) {
                        try {
                            response = await this.removeProdOutputStore(this.formContentOutput.items[key].products[id].output_content_id)
                            window.toastr['success'](i18n.global.t('store.output.notification.lineproduct_delete'))
                            this.formContentOutput.items[key].products.splice(id, 1)
                            if (response.data.count == 0) {
                                this.$router.push('/admin/store/' + this.$route.params.id + '/views/entries')
                                window.toastr['info'](i18n.global.t('store.number_entity') + this.formContentOutput.numero + i18n.global.t('store.entityDontHaveContent'))
                            }
                            return true
                        } catch (e) {
                            if (response && response.data) {
                                window.toastr['error'](response.data.error)
                                return true
                            }
                        }
                    }
                    this.formContentOutput.items[key].products.splice(id, 1)
                }
            })

        },

        initSelect2() {
            $(".kt_select2").select2()
            $(".kt_select2").select2().select2()

            $(document).on('change', '.kt_select2 ', (e) => {
                switch (e.target.name) {
                    case 'shop':
                        this.formContentOutput.items[e.target.getAttribute('data-key')].entityToable_id = e.target.value
                        break;
                    case 'product_sale_element_output_content':
                        let data = {
                            entityFromable_id: this.$route.params.id,
                            productSaleElement_id: e.target.value
                        }
                        // this.loadDetailsProd(data)
                        this.formContentOutput.items[e.target.getAttribute('data-item-key')].products[e.target.getAttribute('data-product-key')].product_sale_element_id = e.target.value
                        this.formContentOutput.items[e.target.getAttribute('data-item-key')].products[e.target.getAttribute('data-product-key')].maxAvailableQuantity = this.getQuantityById(e.target.value)
                        if(this.formContentOutput.items[e.target.getAttribute('data-item-key')].products[e.target.getAttribute('data-product-key')].quantity) {

                        }else {
                          this.formContentOutput.items[e.target.getAttribute('data-item-key')].products[e.target.getAttribute('data-product-key')].quantity = this.getQuantityById(e.target.value)
                        }
                        break;
                        case 'lot':
                          this.formContentOutput.items[e.target.getAttribute('data-item-key')].products[e.target.getAttribute('data-product-key')].product_lot_id = e.target.value
                          break;
                        default:
                        break;
                }
            })

            $(".kt_select2").select2({
                placeholder: this.placeholder
            });
        }
    }
}
</script>

<style scoped>
.badge {
    display: none !important;
    align-items: center;
}

.badge-light-danger {
    color: #f1416c;
    background-color: #fff5f8;
    padding: 15px !important;
    text-align: center !important;
}
</style>